import { SET_CURRENT_DATA_PRIVACY_TERMS } from '../constants/dataPrivacyTermsActionTypes';
import { DataPrivacyTermsActionsTypeAction } from '../constants/dataPrivacyTermsTypes';

export const setCurrentDataPrivacyTerms = (
  dataPrivacyTerms?: string | null
): DataPrivacyTermsActionsTypeAction => ({
  type: SET_CURRENT_DATA_PRIVACY_TERMS,
  dataPrivacyTerms,
});
